import './newFavoriteNotification.css';
// Translate
import { useTranslation } from 'react-i18next';

const NewFavoriteNotification = () => {
	const { t } = useTranslation();
	return (
		<div>
			<p className='text-small-notification'>{t('Successfully saved')}. </p>
			<p className='green-aquinas-text text-small-notification'>
				{t('Find it in your favorites folder')}
			</p>
		</div>
	);
};
export default NewFavoriteNotification;
